import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconLink } from '#src/atoms/icons/system/iconLink.ts';

const Link = styled.a`
  display: flex;
  gap: var(--half-unit);
  font-weight: var(--t-bold);
  align-items: center;

  &.isInline {
    display: inline-flex;
  }
`;

type Props = {
  href: string;
  children: ReactNode;
  inline?: boolean;
  withoutIcon?: boolean;
};
export const ExternalLink = ({
  href,
  children,
  inline,
  withoutIcon,
}: Props) => {
  return (
    <Link
      className={classNames({ isInline: inline })}
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {children}
      {!withoutIcon && <FontAwesomeIcon icon={iconLink} size="xs" />}
    </Link>
  );
};
